<template>
    <div>
      <div class="container"
           id="container">
        <!-- <h1 style="text-align:center;color:aliceblue"> {{  role[index] }}</h1> -->
        <el-row>
          <!-- <el-col :span="1">
            <div class="father">
              <div class="son">
                <el-button type="text"
                           @click="Rotation(index==0?role.length-1:index-1)"><i class="iconfont icon-xiangzuo"
                     style="font-size: 100px"></i></el-button>
              </div>
            </div>
          </el-col> -->
          <el-col :span="24">
            <el-row :gutter="20">
              <el-col :span="12">
                <dv-border-box-11 class="optionChart"
                                  title="操作">
                                  <div class="icondiv">
                    <div>
                      <el-button type="text"
                                 @click="Btnrecruit(name)">
                        <div>
                          <div>
                            <i class="icon iconfont icon-renyuanguanli"
                               style="font-size:100px"></i>
                          </div>
                          <div style="color: #ffffff">人员需求编制</div>
                        </div>
                      </el-button>
                    </div>
                    <div>
                      <el-button type="text"
                                 @click="Btntrain(name)">
                        <div>
                          <div>
                            <i class="icon iconfont icon-zhaopin"
                               style="font-size: 100px"></i>
                          </div>
                          <div style="color: #ffffff">人员招聘</div>
                        </div>
                      </el-button>
                    </div>
  
                    <div>
                      <el-button type="text"
                                 @click="BtnLeague">
                        <div>
                          <div>
                            <i class="icon iconfont icon-xinzipeizhi"
                               style="font-size: 100px"></i>
                          </div>
                          <div style="color: #ffffff">薪资分配</div>
                        </div>
                      </el-button>
                    </div>
                  </div>
                 
                </dv-border-box-11>
              </el-col>
              <el-col :span="12">
                <dv-border-box-11 class="optionChart"
                                  title="员工综合信息">
                                  <dv-charts :option="option"
                             style="width:91%;height:86%;top: 10%;
                      position: relative;
                      left: 5%;" />
                </dv-border-box-11>
              </el-col>
              <el-col :span="12">
                <dv-border-box-11 class="optionChart"
                                  title="员工薪资范围内人员">
                  <!-- <dv-charts :option="salaryOption"
                             style="top: 4%;
                      position: relative;" /> -->
                </dv-border-box-11>
              </el-col>
              <el-col :span="12">
                <dv-border-box-11 class="optionChart"
                                  title="操作">
                  <div class="icondiv">
                    <div>
                      <el-button type="text"
                                 @click="Btnrecruit(name)">
                        <div>
                          <div>
                            <i class="icon iconfont icon-peixunjihua"
                               style="font-size:100px"></i>
                          </div>
                          <div style="color: #ffffff">培训计划编制</div>
                        </div>
                      </el-button>
                    </div>
                    <div>
                      <el-button type="text"
                                 @click="Btntrain(name)">
                        <div>
                          <div>
                            <i class="icon iconfont icon-renyuanpeizhi"
                               style="font-size: 100px"></i>
                          </div>
                          <div style="color: #ffffff">展会现场人员配备</div>
                        </div>
                      </el-button>
                    </div>
  
                    <div>
                      <el-button type="text"
                                 @click="BtnLeague">
                        <div>
                          <div>
                            <i class="icon iconfont icon-ic_saleperformance"
                               style="font-size: 100px"></i>
                          </div>
                          <div style="color: #ffffff">业绩考核</div>
                        </div>
                      </el-button>
                    </div>
                  </div>
                </dv-border-box-11>
              </el-col>
            </el-row>
          </el-col>
          <!-- <el-col :span="1">
            <div class="father">
              <div class="son">
                <el-button type="text"
                           @click="Rotation(index==role.length-1?0:index+1)"><i class="iconfont icon-xiangyou1"
                     style="font-size: 100px"></i></el-button>
              </div>
            </div>
          </el-col> -->
        </el-row>
      </div>
    </div>
  </template>
  
  <script>
  import { mapState } from 'vuex';
  export default {
    components: {
    },
    data () {
      return {
        departmentid: "",
        department: 1,
        Employees: [],
        EmployeesList: [],
        AllComplaint: [],
        option: {
        },
        AllPostList: [],
        PostConfig: {
        },
        postList: [],
        Employemp: [],
        salaryOption: {},
        index: 0,
        name: ''
      }
    },
    created () {
    },
    mounted () {
    },
    computed: {
      ...mapState({
        //Round: (state) => state.user.round,
      })
    },
    methods: {
      Rotation (e) {
        this.index = e;
        let loyalty = 0;
        let exp = 0;
        let profession = 0;
        let morality = 0;
        let energy = 0;
        let data = [];
        let postData = []
        this.name = this.role[this.index]
        switch (this.role[this.index]) {
          case '财务管理':
            this.departmentid = 32
            break;
          case '市场营销':
            this.departmentid = 2
            break;
          case '工程运维':
            this.departmentid = 64
            break;
          case '前厅客房':
            this.departmentid = 1
            break;
          case '人力资源':
            this.departmentid = 16
            break;
          case '餐饮娱乐':
            this.departmentid = 4
            break;
        }
        let employeList = this.Employees.filter(t => t.state != this.Global.SModel.Delete);
        switch (this.departmentid) {
          case 4:
            this.EmployeesList = this.Employees.filter(t => (t.departmentid == 4 || t.departmentid == 8) && t.state != this.Global.SModel.Delete)
            loyalty = this.EmployeesList.length == 0 ? 0 : parseInt(this.EmployeesList.reduce((sum, e) => sum + Number(e.loyalty), 0) / this.EmployeesList.length)//员工的忠诚度
            exp = this.EmployeesList.length == 0 ? 0 : parseInt(this.EmployeesList.reduce((sum, e) => sum + Number(e.exp), 0) / this.EmployeesList.length)//
            profession = this.EmployeesList.length == 0 ? 0 : parseInt(this.EmployeesList.reduce((sum, e) => sum + Number(e.profession), 0) / this.EmployeesList.length)//
            morality = this.EmployeesList.length == 0 ? 0 : parseInt(this.EmployeesList.reduce((sum, e) => sum + Number(e.morality), 0) / this.EmployeesList.length)//
            energy = this.EmployeesList.length == 0 ? 0 : parseInt(this.EmployeesList.reduce((sum, e) => sum + Number(e.energy), 0) / this.EmployeesList.length)//
            this.postList = this.groupBy(this.Employees.filter(t => t.state != this.Global.SModel.Delete && (t.departmentid == 4 || t.departmentid == 8)), function (item) {
              return [item]
            })
            for (let i = 0; i < this.postList.length; i++) {
              postData.push({
                name: this.AllPostList.filter(t => t.id == this.postList[i][0].postId)[0].name,
                value: this.EmployeesList.filter(t => t.postId == this.postList[i][0].postId).length
              })
            }
            this.salaryOption = {
              xAxis: {
                data: ['3-6K', '6-9K', '9-12K', '12-15K', '15K+'],
                axisLine: {
                  style: {
                    stroke: "#999",
                  },
                },
                axisLabel: {
                  style: {
                    fill: "#999",
                  },
                },
                axisTick: {
                  show: false,
                },
              },
              yAxis: {
                name: '人员数量',
                data: 'value',
                splitLine: {
                  show: false,
                },
                axisLine: {
                  style: {
                    stroke: "#999",
                  },
                },
                axisLabel: {
                  style: {
                    fill: "#999",
                  },
                },
                axisTick: {
                  show: false,
                },
                min: 0,
              },
              series: [
                {
                  data: [employeList.length == 0 ? 0 : this.EmployeesList.filter(t => t.salary >= 3000 && t.salary <= 6000).length,
                  employeList.length == 0 ? 0 : this.EmployeesList.filter(t => t.salary > 6000 && t.salary <= 9000).length,
                  employeList.length == 0 ? 0 : this.EmployeesList.filter(t => t.salary > 9000 && t.salary <= 12000).length,
                  employeList.length == 0 ? 0 : this.EmployeesList.filter(t => t.salary > 12000 && t.salary <= 15000).length,
                  employeList.length == 0 ? 0 : this.EmployeesList.filter(t => t.salary > 15000).length],
                  type: 'bar'
                }
              ]
            }
            if (postData.length == 0) {
              var post1 = this.AllPostList.filter(x => x.department == 4 || x.department == 8)
              post1.forEach(o => {
                postData.push({
                  name: o.name,
                  value: 0
                });
              })
            }

            data.push(loyalty, exp, profession, morality, energy);
            this.option = {
              radar: {
                indicator: [
                  { name: "忠诚度", max: 100 },
                  { name: "工作熟练度", max: 100 },
                  { name: "技能水平", max: 100 },
                  { name: "品德水平", max: 100 },
                  { name: "精力", max: 100 },
                ],
                axisLabel: {
                  style: {
                    fontSize: 15,
                    fill: 'white'
                  }
                },
                polygon: true,
                splitLine: {
                  style: {
                    stroke: 'rgba(159, 230, 184, 1)'
                  }
                },
              },
              series: [
                {
                  type: 'radar',
                  data: data,
                  label: {
                    style: {
                      fontSize: 15,
                      fill: 'white'
                    }
                  },
                  animationCurve: 'easeOutBack'
                }
              ]
            }
            break;
          default:
            this.EmployeesList = this.Employees.filter(t => t.departmentid == this.departmentid && t.state != this.Global.SModel.Delete)
            loyalty = this.EmployeesList.length == 0 ? 0 : parseInt(this.EmployeesList.reduce((sum, e) => sum + Number(e.loyalty), 0) / this.EmployeesList.length)//员工的忠诚度
            exp = this.EmployeesList.length == 0 ? 0 : parseInt(this.EmployeesList.reduce((sum, e) => sum + Number(e.exp), 0) / this.EmployeesList.length)//
            profession = this.EmployeesList.length == 0 ? 0 : parseInt(this.EmployeesList.reduce((sum, e) => sum + Number(e.profession), 0) / this.EmployeesList.length)//
            morality = this.EmployeesList.length == 0 ? 0 : parseInt(this.EmployeesList.reduce((sum, e) => sum + Number(e.morality), 0) / this.EmployeesList.length)//
            energy = this.EmployeesList.length == 0 ? 0 : parseInt(this.EmployeesList.reduce((sum, e) => sum + Number(e.energy), 0) / this.EmployeesList.length)//
            this.postList = this.groupBy(this.Employees.filter(t => t.state != this.Global.SModel.Delete && t.departmentid == this.departmentid), function (item) {
              return [item]
            })
            for (let i = 0; i < this.postList.length; i++) {
              postData.push({
                name: this.AllPostList.filter(t => t.id == this.postList[i][0].postId)[0].name,
                value: this.EmployeesList.filter(t => t.postId == this.postList[i][0].postId).length
              })
            }
            this.salaryOption = {
              xAxis: {
                data: ['3-6K', '6-9K', '9-12K', '12-15K', '15K+'],
                axisLine: {
                  style: {
                    stroke: "#999",
                  },
                },
                axisLabel: {
                  style: {
                    fill: "#999",
                  },
                },
                axisTick: {
                  show: false,
                },
              },
              yAxis: {
                name: '人员数量',
                data: 'value',
                nameTextStyle: {
                  fill: '#999',
                  fontSize: 10
                },
                splitLine: {
                  show: false,
                },
                axisLine: {
                  style: {
                    stroke: "#999",
                  },
                },
                axisLabel: {
                  style: {
                    fill: "#999",
                  },
                },
                axisTick: {
                  show: false,
                },
                min: 0,
              },
              series: [
                {
                  data: [this.Employees.length == 0 ? 0 : this.EmployeesList.filter(t => t.salary >= 3000 && t.salary <= 6000).length,
                  this.Employees.length == 0 ? 0 : this.EmployeesList.filter(t => t.salary > 6000 && t.salary <= 9000).length,
                  this.Employees.length == 0 ? 0 : this.EmployeesList.filter(t => t.salary > 9000 && t.salary <= 12000).length,
                  this.Employees.length == 0 ? 0 : this.EmployeesList.filter(t => t.salary > 12000 && t.salary <= 15000).length,
                  this.Employees.length == 0 ? 0 : this.EmployeesList.filter(t => t.salary > 15000).length],
                  type: 'bar'
                }
              ]
            }
            if (postData.length == 0) {
              var post = this.AllPostList.filter(x => x.department == this.departmentid)
              post.forEach(o => {
                postData.push({
                  name: o.name,
                  value: 0
                });
              })
            }
            this.PostConfig = {
              data: postData,
              unit: '人',
              rowNum: 4
            }
            data.push(loyalty, exp, profession, morality, energy);
            this.option = {
              radar: {
                indicator: [
                  { name: "忠诚度", max: 100 },
                  { name: "工作熟练度", max: 100 },
                  { name: "技能水平", max: 100 },
                  { name: "品德水平", max: 100 },
                  { name: "精力", max: 100 },
                ],
                axisLabel: {
                  style: {
                    fontSize: 15,
                    fill: 'white'
                  }
                },
                polygon: true,
                splitLine: {
                  style: {
                    stroke: 'rgba(159, 230, 184, 1)'
                  }
                },
              },
              series: [
                {
                  type: 'radar',
                  data: data,
                  label: {
                    style: {
                      fontSize: 15,
                      fill: 'white'
                    }
                  },
                  animationCurve: 'easeOutBack'
                }
              ]
            }
            break;
        }
    }
      },
  }
  </script>
  <style lang="less" scoped>
  .icondiv {
    display: flex;
    flex-flow: wrap;
    justify-content: center;
    padding-top: 20px;
    height: 90%;
    align-content: center;
    align-items: center;
    overflow: auto;
    > div {
      display: flex;
      width: 30%;
      text-align: center;
      height: 40%;
      justify-content: center;
    }
  }
  </style>
  <style scoped>
  .h1 {
    position: fixed;
    bottom: 30px;
    right: 5px;
  }
  .optionChart {
    width: 90%;
    height: calc(80vh / 2);
    margin-right: 10px;
    border-radius: 20px;
  }
  .posttitile {
    text-align: center;
    color: white;
  }
  .father {
    position: relative;
    width: calc(80vm);
    height: calc(80vh);
  }
  .son {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -50px;
    margin-top: -50px;
    margin-right: -50px;
  }
  #container {
    width: calc(90vm);
    height: 100%;
    background-image: url("../../images/bg.png");
    flex: auto;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .Rotation {
    width: calc(5vm);
    height: calc(5vh);
  }
  
  .btn {
    width: 100%;
    height: 100%;
    margin-top: 10px;
    text-align: center;
  }
  </style>